// PrivateRoute.jsx
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
    const accessToken = useSelector((state) => state.auth.accessToken );
 if (!accessToken && location.pathname !== "/auth/login") {
    return <Navigate to="/auth/login" replace />;
  }

  if (accessToken && (location.pathname === "/auth/login" || location.pathname === "/")) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
};

export default PrivateRoute;


